<template> 
  <div style="background-color:lightgray;">
    <carousel-3d :disable3d="true" :clickable="false" :autoplay="true" :autoplay-timeout="5000" :controls-prev-html="'&laquo;'" :controls-next-html="'&raquo;'" style="z-index:100;position:absolute;top:75vh;">
      <slide :index="8" style="width:200px;background-color:transparent;border:none">
        <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
          <img :src="codedImages.carousel_3d.agriculture" width="100%" alt="">              
          <div style="padding-top:5px;">
            <div style="font-size:12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>Agriculture </b></div>
            <div style="font-size:12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">Insurance</div>
          </div>                
          <div style="text-align:center;padding:5px;">
            <v-btn
              color="whitesmoke"
              rounded
              outlined
              small  
              @click="redirect('products')"        
            >
              View Details
            </v-btn>
          </div>
          <div style="text-align:right;padding:5px">
            <a
              @click="redirect('products')" 
              style="font-size:12px" 
            >
              Learn more
            </a>
          </div>
        </v-card>
      </slide>
      <slide :index="0" style="width:200px;background-color:transparent;border:none">
        <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
          <img :src="codedImages.carousel_3d.overseas" width="100%" alt="">              
          <div style="padding-top:5px;">
            <div style="font-size:12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>Overseas Travel</b></div>
            <div style="font-size:12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">Insurance</div>
          </div>                
          <div style="text-align:center;padding:5px;">
            <v-btn
              color="whitesmoke"
              rounded
              outlined
              small  
              @click="openDrawer(3)"        
            >
              Get a Quote
            </v-btn>
          </div>
          <div style="text-align:right;padding:5px">
            <a
              @click="redirect('products')" 
              style="font-size:12px" 
            >
              Learn more
            </a>
          </div>
        </v-card>
      </slide>
      <slide :index="1" style="width:200px;background-color:transparent;border:none">
        <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
          <img :src="codedImages.carousel_3d.motor" width="100%" alt="">              
          <div style="padding-top:5px;">
            <div style="font-size: 12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>Motor</b></div>
            <div style="font-size: 12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">Insurance</div>
          </div>                
          <div style="text-align:center;padding:5px">
            <v-btn
              color="whitesmoke"
              rounded
              outlined
              small  
              @click="openDrawer(1)" 
            >
              Get a Quote
            </v-btn>
          </div>
          <div style="text-align:right;padding:5px">
            <a
              href="/products" 
              style="font-size:12px" 
            >
              Learn more
            </a>
          </div>
        </v-card>
      </slide>
      <slide :index="2" style="width:200px;background-color:transparent;border:none">
        <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
          <img :src="codedImages.carousel_3d.household" width="100%" alt="">              
          <div style="padding-top:5px;">
            <div style="font-size: 12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>Household Goods</b></div>
            <div style="font-size: 12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">Insurance</div>
          </div>                
          <div style="text-align:center;padding:5px">
            <v-btn
              color="whitesmoke"
              rounded
              outlined      
              small
              @click="redirect('products')"
            >
              View Details
            </v-btn>
          </div>
        </v-card>
      </slide>
      <slide :index="3" style="width:200px;background-color:transparent;border:none">
        <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
          <img :src="codedImages.carousel_3d.muende_bwino" width="100%" alt="">              
          <div style="padding-top:5px;">
            <div style="font-size: 12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>Muende Bwino</b></div>
            <div style="font-size: 12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">Insurance</div>
          </div>                
          <div style="text-align:center;padding:5px">
            <v-btn
              color="whitesmoke"
              rounded
              outlined
              small  
              @click="openDrawer(5)"         
            >
              Get a Quote
            </v-btn>
          </div>
          <div style="text-align:right;padding:5px">
            <a
              href="/products" 
              style="font-size:12px" 
            >
              Learn more
            </a>
          </div>
        </v-card>
      </slide>
      <slide :index="4" style="width:200px;background-color:transparent;border:none">
        <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
          <img :src="codedImages.carousel_3d.house" width="100%" alt="">              
          <div style="padding-top:5px;">
            <div style="font-size: 12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>House Owners</b></div>
            <div style="font-size: 12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">Insurance</div>
          </div>                
          <div style="text-align:center;padding:5px">
            <v-btn
              color="whitesmoke"
              rounded
              outlined   
              small  
              @click="openDrawer(2)"  
            >
              Get a Quote
            </v-btn>
          </div>
          <div style="text-align:right;padding:5px">
            <a
              href="/products" 
              style="font-size:12px" 
            >
              Learn more
            </a>
          </div>
        </v-card>
      </slide>
      <slide :index="5" style="width:200px;background-color:transparent;border:none">
        <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
          <img :src="codedImages.carousel_3d.picz_app" width="100%" alt="">              
          <div style="padding-top:5px;">
            <div style="font-size: 12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>Get the MyPICZ</b></div>
            <div style="font-size: 12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">Mobile App</div>
          </div>                
          <div style="text-align:center;padding:5px">
            <v-btn
              color="whitesmoke"
              rounded
              outlined
              small 
              @click="redirect('mobile_app')"             
            >
              Download Now
            </v-btn>
          </div>
        </v-card>
      </slide>
      <slide :index="6" style="width:200px;background-color:transparent;border:none">
        <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
          <img :src="codedImages.carousel_3d.engineering" width="100%" alt="">              
          <div style="padding-top:5px;">
            <div style="font-size: 12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>Engineering</b></div>
            <div style="font-size: 12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">Insurance</div>
          </div>                
          <div style="text-align:center;padding:5px">
            <v-btn
              color="whitesmoke"
              rounded
              outlined
              small     
              @click="redirect('products')"
            >
              View Details
            </v-btn>
          </div>
        </v-card>
      </slide>
      <slide :index="7" style="width:200px;background-color:transparent;border:none">
        <a href="https://wa.me/260956659857" target="_blank">
          <v-card style="height:240px;background-color:rgb(245,245,220,0.90)">
            <img :src="codedImages.carousel_3d.whatsapp" width="100%" alt="">              
            <div style="padding-top:5px;">
              <div style="font-size: 12px;padding-left:30px;font-family:Tahoma;color:rgb(5,47,102);"><b>Message Us</b></div>
              <div style="font-size: 12px;padding-left:30px;font-family:Roboto;color:rgb(5,47,102);">On WhatsApp</div>
            </div>                
            <div style="text-align:center;padding:5px">
              <p style="font-size:12px;font-family:Tahoma;color:black;"><b>+260 956 659 857</b></p>
            </div>
          </v-card>
        </a>
      </slide>
    </carousel-3d>
    <div style="text-align:center;">
      <div style="padding-top:200px">
        <h5><p class="picz_color">Who we are</p></h5>
        <div class="about">
          <p>With over 28 years of insurance experience, <span style="color:#052F66"><b>Professional Insurance Corporation</b></span> is the leading General Insurance Company in Zambia. Our vision is to be a world class provider of quality insurance.
            Our mission is to consistently exceed the expectations of our customers. The Corporation has maintained an A+ Credit Rating for 8 years running and in 2019, Professional Insurance paid out a total of 4,600 claims with a monetary value in excess of K132 million.

          </p>
        </div>
        <div class="learn_more">
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-btn
                large
                text
                outlined
                color="#052F66"
                width="200px"
                style="border:solid 1px"
                @click="redirect('about')"
              >
                Learn More
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-btn
                large
                text
                outlined
                color="#052F66"
                width="200px"
                style="border:solid 1px;"          
                @click="redirect('login')"  
              >
                Get Started
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-btn
                large
                text
                outlined
                color="#052F66"
                width="200px"
                style="border:solid 1px;"     
                @click="redirect('contact')"             
              >
                Contact Us
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
      <div style="padding-top:60px">
        <h5><p style="color:#052F66">Reasons to choose Professional Insurance</p></h5>
        <div style="padding-left:150px;padding-right:150px">
          <v-row>
            <v-col
              cols="12"
              sm="3"
            >
              <img
                v-lazy="require(`@/assets/values/proactive.png`)"
                alt=""
                class="center"              
              />
              <div style="padding-bottom:5px;padding-top:15px;color:#052F66">
                Proactive
              </div>
              <p>
                We Proactively offer solutions to our<br /> customers' needs.
              </p>
            </v-col>
            <v-col
              cols="12"
              sm="3"
            >
              <img
                v-lazy="require(`@/assets/values/integrity.png`)"
                alt=""
                class="center"            
              />
              <div style="padding-bottom:5px;padding-top:15px;color:#052F66">
                Integrity
              </div>
              <p>
                We are absolutely honest in all our<br /> dealings.
              </p>
            </v-col>
            <v-col
              cols="12"
              sm="3"
            >
              <div style="text-align:center">
                <img
                  v-lazy="require(`@/assets/values/creative.svg`)"
                  alt=""
                  class="center"                            
                />
              </div>
              <div style="padding-bottom:5px;padding-top:15px;color:#052F66">
                Creativity
              </div>
              <p>
                We are appropriately innovative in<br /> our execution.
              </p>
            </v-col>
            <v-col
              cols="12"
              sm="3"
            >
              <img
                v-lazy="require(`@/assets/values/zeal.png`)"
                alt=""
                class="center"            
              />
              <div style="padding-bottom:5px;padding-top:15px;color:#052F66">
                Zeal
              </div>
              <p>
                We deliver our service with commitment<br /> at all times.
              </p>
            </v-col>
          </v-row>
        </div>
      </div>
      <div style="padding-top:60px">
        <h5><p class="picz_blue">What people say about us</p></h5>
        <div class="testimonials">
          <p>Choosing an insurance company is a big decision and it's often helpful to hear what others have to say. We have gathered feedback from a number of clients to help you with your decision.<br /> 
          Please feel free to contact us for further clarifications.
          </p>
        </div>
        <div class="testimonial_content">
          <div class="speech">
            <em>"They pay on time."</em><p class="user">Moses Miti, Zambia</p>
          </div>
          <div class="speech">
            <em>"They are reliable and live up to the name."</em><p class="user">Detroit Simz, Zambia</p>
          </div>
          <div class="speech">
            <em>"The best so far keep up the good work!!!!"</em><p class="user">Maura Bwalya, Zambia</p>
          </div>
          <div class="speech">
            <em>"Their legal team is excellent!"</em><p class="user">Godfrey Kapenda, Zambia</p>
          </div>
          <div class="speech"> 
            <em>"Yes ...they are the best and worthy of the name....!!"</em><p class="user">Beatrice Kaite, Zambia</p>
          </div>
          <div class="speech"> 
            <em>"They are the best in Zambia...kudos to Professional Insurance team..."</em><p class="user"> Chimwemwe Simsokwe, Zambia</p>
          </div>
          <div class="speech">
            <em>"Professional Insurance are the best in Zambia, so professional!!!"</em><p class="user">Eugene R Wamulume, Zambia</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Home',
    components: {
      
    },
    data() {
      return {
        values_imgs: [
          `http://35.242.182.168/wb_imgs/values/creative.svg`,
          `http://35.242.182.168/wb_imgs/values/integrity.png`,
          `http://35.242.182.168/wb_imgs/values/proactive.png`,
          `http://35.242.182.168/wb_imgs/values/zeal.png`
        ]
      }
    },
    methods: {
      redirect(path){
        this.$router.push(path);      
      },
      openDrawer(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
      openBottomSheet(index){
        this.components.bottom_sheet.option_index=index;
        this.components.bottom_sheet.is_open=true;
        
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components",
        codedImages: "codedImages"
      })
    } 
  }
</script>
<style lang="css">
  .center{
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 60%;
  }
  .speech {
    background-color: #f6f6f6;
    height:80px;
    margin-bottom: 15px;
    padding: 10px 15px;
    border-radius: 5px;
    color:#052F66;    
  }
  .user {
    float: right;
    color: maroon;
  }
  .location {
    float: right;
    color: black;
  }
  .testimonials {
    padding:10vw;
    text-align:centre;
    color:black;
  }
  .testimonial_content {
    
      padding-left:10vw;
      padding-right:10vw;
      text-align:left        
  }
  .picz_blue {
    color:#052F66
  }
  .about {
    
      padding-left:10vw;
      padding-right:10vw;
      text-align:center        
  }
  .learn_more {

      padding-left:20vw;
      padding-right:20vw;       
  } 
  
</style>
